document.addEventListener('DOMContentLoaded', () => {

  const bars = document.querySelectorAll('.wg-announcement-bar');

  if (!bars.length) return;

  bars.forEach((bar) => {

    const track = bar.querySelector('.wg-announcement-bar__track');
    const items = [...bar.querySelectorAll('.wg-announcement-item')];

    if (!track || items.length === 0) return;

    let speed = parseInt(track.dataset.speed, 10) || 4;

    let timer = null;

    function isMobile() {
      return window.innerWidth < 768;
    }

    function isTablet() {
      return window.innerWidth >= 768 && window.innerWidth <= 1024;
    }

    function resetItems() {
      items.forEach((item) => {
        item.classList.remove('active');
        item.style.position = '';
        item.style.opacity = '';
        item.style.transform = '';
      });
    }

    /* ---------------------------------------
       MOBILE ROTATION
    --------------------------------------- */

    function startRotation() {

      if (!isMobile()) return;

      let index = 0;

      resetItems();

      items[0].classList.add('active');

      timer = setInterval(() => {

        items[index].classList.remove('active');

        index++;

        if (index >= items.length) {
          index = 0;
        }

        items[index].classList.add('active');

      }, speed * 1000);

    }

    function stopRotation() {

      if (timer) {

        clearInterval(timer);

        timer = null;

      }

    }

    /* ---------------------------------------
       TABLET AUTO SCROLL
    --------------------------------------- */

    function startTabletScroll() {

      if (!isTablet()) return;

      let current = 0;

      const cardWidth = track.clientWidth / 2;

      timer = setInterval(() => {

        current++;

        if (current >= items.length) {

          current = 0;

        }

        track.scrollTo({

          left: current * cardWidth,

          behavior: 'smooth'

        });

      }, speed * 1000);

    }

    /* ---------------------------------------
       INITIALIZE
    --------------------------------------- */

    function init() {

      stopRotation();

      resetItems();

      if (isMobile()) {

        startRotation();

      } else if (isTablet()) {

        startTabletScroll();

      }

    }

    init();

    window.addEventListener('resize', () => {

      stopRotation();

      init();

    });

  });

});